import { useContext } from 'react';

import { AxiosContext, AxiosContextType } from '../context/AxiosContext';
import { UserContextType } from '../interfaces/index';

export function useUser(userContext: UserContextType) {
  const { axios } = useContext<AxiosContextType>(AxiosContext);

  const loadMe = async () => {
    try {
      const res = await axios?.get(`/me`);

      if (res?.data) {
        await userContext.updateUserCtx((draft: any) => {
          draft.user = res.data;
        });
      }
    } catch (error) {
      console.log(error);
      userContext.updateUserCtx((draft: any) => {
        draft.token = undefined;
      });

      return Promise.reject(error);
    }
  };

  return {
    loadMe,
  };
}
